module.exports = __webpack_public_path__ + "static/img/pos_product_qrcode.e76f682.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/pos_product_qrcode.png
// module id = uSsv
// module chunks = 8